import React from "react";

const ACCOUNT_ROLE_BADGES = {
  user: { label: "Member", className: "bg-[#EAF2FF] text-[#00ADEF]" },
  member: { label: "Member", className: "bg-[#EAF2FF] text-[#00ADEF]" },
  merchant: { label: "Merchant", className: "bg-[#FFF5E6] text-[#C27A00]" },
  fundraiser: { label: "Fundraiser", className: "bg-[#E9EAEC] text-[#252A31]" },
  admin: { label: "Admin", className: "bg-[#E9EAEC] text-[#252A31]" },
};

const MultipleAccountsModal = ({
  email,
  accountCount,
  roles = [],
  onCancel,
  onContinue,
  loading = false,
}) => {
  const roleBadges = [
    ...new Map(
      roles.map((role) => {
        const badge = ACCOUNT_ROLE_BADGES[role] || {
          label: role,
          className: "bg-[#E9EAEC] text-[#252A31]",
        };
        return [badge.label, badge];
      }),
    ).values(),
  ];

  return (
    <div className="fixed inset-0 z-[110] flex items-center justify-center overflow-y-auto bg-[#15171B]/50 px-4 py-6">
      <div
        className="relative w-full max-w-[494px] rounded-[24px] bg-white px-6 py-7 shadow-2xl sm:px-7"
        role="dialog"
        aria-modal="true"
        aria-labelledby="reset-accounts-title"
      >
        <button
          type="button"
          aria-label="Close password reset confirmation"
          onClick={onCancel}
          disabled={loading}
          className="absolute right-5 top-5 text-[28px] leading-none text-[#687080] disabled:opacity-50"
        >
          ×
        </button>
        <div className="mb-4 flex h-12 w-12 items-center justify-center rounded-full bg-[#EAF5FF] text-[#00ADEF]">
          <svg
            viewBox="0 0 24 24"
            className="h-6 w-6"
            fill="none"
            stroke="currentColor"
            strokeWidth="1.8"
            aria-hidden="true"
          >
            <circle cx="8" cy="15" r="4" />
            <path d="m10.8 12.2 8.7-8.7m-3.2 3.2 2.2 2.2m-5.1.9 2.2 2.2" />
          </svg>
        </div>
        <h2
          id="reset-accounts-title"
          className="pr-8 text-[21px] font-[700] leading-tight text-[#20232A] sm:text-[23px]"
        >
          This password is used for all your accounts
        </h2>
        <p className="mt-4 break-words text-[14px] leading-[1.5] text-[#687080]">
          {email} is linked to {accountCount || roles.length} Swoodle accounts. Your new
          password will work for all of them:
        </p>
        <div className="mt-3 flex flex-wrap gap-2">
          {roleBadges.map(({ label, className }) => (
            <span
              key={label}
              className={`rounded-full px-3 py-1.5 text-[13px] font-[500] ${className}`}
            >
              {label}
            </span>
          ))}
        </div>
        <div className="mt-4 flex gap-3 rounded-[12px] bg-[#F3F5F7] px-3 py-3 text-[12px] leading-[1.5] text-[#687080]">
          <span className="flex h-5 w-5 shrink-0 items-center justify-center rounded-full border border-[#687080] font-[600]">
            i
          </span>
          <p>
            After the reset, use your new password to log in to the app and the
            web portal.
          </p>
        </div>
        <div className="mt-4 flex justify-end gap-3">
          <button
            type="button"
            onClick={onCancel}
            disabled={loading}
            className="h-[48px] rounded-[12px] border border-[#E1E5EA] px-5 font-[600] text-[#20232A] disabled:opacity-50"
          >
            Cancel
          </button>
          <button
            type="button"
            onClick={onContinue}
            disabled={loading}
            className="h-[48px] rounded-[12px] bg-[#00ADEF] px-5 font-[600] text-white disabled:cursor-not-allowed disabled:opacity-60"
          >
            {loading ? "Resetting..." : "Continue to reset"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default MultipleAccountsModal;
